import PromotionCodesManager from './promotion-codes';
import FormsManager from './forms';
import DataCollectionsManager from './data-collections';
import DataCollectionFiltersManager from './data-collection-filters';
import MetricsManager from './metrics';
import CustomerFiltersManager from './customer-filters';
import TemplatesManager from './templates';
import ConversationFiltersManager from './conversation-filters';
import SentMessageBookmarksManager from './sent-message-bookmarks';

const PublicManagers = [];

const PrivateManagers = [
  ['PromotionCodesManager', PromotionCodesManager],
  ['FormsManager', FormsManager],
  ['DataCollectionsManager', DataCollectionsManager],
  ['DataCollectionFiltersManager', DataCollectionFiltersManager],
  ['MetricsManager', MetricsManager],
  ['CustomerFiltersManager', CustomerFiltersManager],
  ['TemplatesManager', TemplatesManager],
  ['ConversationFiltersManager', ConversationFiltersManager],
  ['SentMessageBookmarksManager', SentMessageBookmarksManager]
];

class DataManagers {
  constructor(application) {

    this.application = application;

    this.publicManagers = this.createManagers(PublicManagers);
    this.privateManagers = this.createManagers(PrivateManagers);

    this.managers = [
      ...this.publicManagers,
      ...this.privateManagers
    ];

  }

  createManagers(Managers) {

    const managers = [];

    for (let [name, Manager] of Managers) {
      const manager = new Manager(this.application);
      managers.push({ name, manager });
    }

    return managers;

  }

  async initializeManagers(managers, bootstrapData) {

    let promises = [];

    for (let { manager } of managers) {
      promises.push(manager.initialize(bootstrapData));
    }

    return Promise.all(promises);

  }

  async initializePublicManagers() {

    await this.initializeManagers(this.publicManagers);

  }

  async initializePrivateManagers(bootstrapData) {

    await this.initializeManagers(this.privateManagers, bootstrapData);

  }

  get(expectedName) {

    const managers = this.managers;

    for (let { name, manager } of managers) {

      if (name === expectedName) {
        return manager;
      }

    }

    throw new Error(`Manager with name ${expectedName} not found`);

  }

}

export default DataManagers;